require('../../modules/es6.object.is-frozen');
module.exports = require('../../modules/_core').Object.isFrozen;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/is-frozen.js
// module id = 49
// module chunks = 0